const SESSION_SYNC_KEY = 'drcc-session-sync'

function broadcastAuthEvent(event, userId = null) {
  localStorage.setItem(SESSION_SYNC_KEY, JSON.stringify({
    event,
    userId,
    timestamp: Date.now(),
  }))
}

function parseSessionSyncEvent(storageEvent) {
  if (!storageEvent || storageEvent.key !== SESSION_SYNC_KEY || !storageEvent.newValue) {
    return null
  }

  try {
    return JSON.parse(storageEvent.newValue)
  } catch (error) {
    console.error('Failed to parse session sync event:', error)
    return null
  }
}

function shouldInvalidateTab(localUserId, payload) {
  if (!localUserId || !payload) {
    return false
  }

  return payload.event === 'login' || payload.event === 'logout'
}

export {
  SESSION_SYNC_KEY,
  broadcastAuthEvent,
  parseSessionSyncEvent,
  shouldInvalidateTab,
}
